import { instance } from '@/utils/http.js'

// 我的试卷-获取试卷列表
export const getTeacherPaperList = (params) => {
  return instance({
    url: '/api/v1/teacher/teacher_paper',
    method: 'get',
    params
  })
}

export const getBxList = function (params) {
  return instance({
    url: '/api/v1/public/bx_subjects',
    method: 'get',
    params
  })
}